import React, {useCallback, useMemo, useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
//local
import {IconFeather} from "components/icons";
import {color} from "constants/color.consts";
import {getInvoiceProfiles} from "../../SignContracts/api/contracts";
import {contractStatus, sortContractsSelectItems} from "constants/buyer.consts";
import {defaultUpdatedFieldSearch} from "constants/user.consts";
import MiniSelect from "components/selects/MiniSelect";
import MultipleSelect from "components/selects/MultipleSelect";
import StatusesSelect from "components/selects/StatusesSelect";

const statuses = Object.values(contractStatus);

export const ContractsFilter = ({filters, setFilters}) => {
  const {t} = useTranslation();
  const [invoiceProfiles, setInvoiceProfiles] = useState([]);

  const sortValue = useMemo(
    () => `${defaultUpdatedFieldSearch.field}|${defaultUpdatedFieldSearch.direction}`,
    []
  );
  const selectedInvoiceProfiles = useMemo(
    () =>
      invoiceProfiles.filter((profile) =>
        filters?.invoiceProfileIds?.includes(profile.value)
      ),
    [filters?.invoiceProfileIds, invoiceProfiles]
  );

  const getProfiles = useCallback(
    async () =>
      await getInvoiceProfiles({size: 9999}).then(({invoiceProfiles}) =>
        setInvoiceProfiles(
          invoiceProfiles.map(({id, name}) => ({value: id, label: name}))
        )
      ),
    []
  );

  const handleChangeTypes = (value) =>
    setFilters({
      ...filters,
      page: 1,
      status: value.length === statuses.length ? null : value,
    });

  const handleSortChange = (value) => {
    const params = {field: value.split("|")[0], direction: value.split("|")[1]};
    onSelectChange("sort", params);
  };

  const handleInvoiceProfileChange = (value) => {
    const data = value.map((item) => item.value);
    onSelectChange("invoiceProfileIds", data);
  };

  const onSelectChange = (name, value) => {
    const params = name === "sort" ? {...filters, ...value} : {...filters, [name]: value};
    if (!value || (Array.isArray(value) && !value.length)) delete params[name];
    setFilters(name === "page" ? params : {...params, page: 1});
  };

  const canFilterByInvoiceProfile = useMemo(
    () => !filters?.status || filters?.status?.includes("CONTRACT_TYPE_HANDYSIGN"),
    [filters?.status]
  );

  useEffect(() => {
    canFilterByInvoiceProfile && !invoiceProfiles.length && getProfiles();
  }, [canFilterByInvoiceProfile, invoiceProfiles.length, getProfiles]);

  useEffect(() => {
    !canFilterByInvoiceProfile &&
      filters?.invoiceProfileIds &&
      delete filters.invoiceProfileIds;
  }, [canFilterByInvoiceProfile, filters?.invoiceProfileIds]);

  return (
    <div className="df-row-center ml-8 mb-4">
      <MiniSelect
        key={sortValue}
        list={sortContractsSelectItems}
        defaultValue={sortValue}
        label={t("SORT")}
        prefixLabel
        boldLabel
        tinyLabel
        uppercaseLabel
        itemAsObject
        addClass="mr-4"
        onChange={handleSortChange}
      />

      <StatusesSelect
        list={statuses}
        label="CONTRACTS_PAGE_TYPE_FILTER_LABEL"
        prefixLabel
        boldLabel
        tinyLabel
        uppercaseLabel
        selectStatus="CONTRACTS_PAGE_TYPE_SELECT_STATUS"
        someStatuses="CONTRACTS_PAGE_TYPE_STATUS_STATUSES"
        noStatus="CONTRACTS_PAGE_TYPE_STATUS_NO_STATUS"
        multiple
        itemColor="black"
        onChange={handleChangeTypes}
        defaultValue={filters?.status ?? statuses}
      />

      {canFilterByInvoiceProfile && (
        <MultipleSelect
          title="CONTRACTS_PAGE_INVOICE_PROFILE_LABEL"
          titleInButton
          value={selectedInvoiceProfiles}
          list={invoiceProfiles}
          leftIcon={<IconFeather color={color.black} addClass="fs0 mt-[3] mr-2" />}
          tiny
          maxSelectionsInRow={3}
          uppercaseButton
          color="black"
          realLabels
          onChange={handleInvoiceProfileChange}
          addClass="mla"
          alignRight
        />
      )}
    </div>
  );
};
